<template>
    <IconBase  v-bind="$props" v-on="$listeners">
        <path d="M15 1L8 7L1 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </IconBase>
</template>


<script>
import IconBase from './iconBase/IconBase.vue'
import iconProps from './iconBase/iconProps.js'

export default {
  components: { IconBase },
  props: {
    ...iconProps,
    height: {
        ...iconProps.height,
        default: 8,
    },
    width: {
        ...iconProps.width,
        default: 16,
    },
    viewBox: {
        ...iconProps.viewBox,
        default: "0 0 16 8",
    }
  },
}
</script>